import { useTran } from "@/hooks";
import PillTabs from "@/components/common/PillTabs";

const DataTableViewSelector = ({ value, onChange }) => {
  const { t } = useTran();
  const tabs = [
    { value: "year", label: t("Year") },
    { value: "bu", label: t("BU") },
    { value: "country", label: t("Country") },
  ];
  return (
    <div className="flex items-center gap-2">
      <span className="text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">
        {t("View by")}
      </span>
      <PillTabs tabs={tabs} value={value} onChange={onChange} size="sm" />
    </div>
  );
};

export default DataTableViewSelector;
